export function generateEnterKeyPressedHandler(eventHandler: any) {
  return (event: any) => {
    if (event.key === 'Enter' && eventHandler) {
      eventHandler()
    }
  }
}
